import ResidenceHistory from './ResidenceHistory';

export default ResidenceHistory;
